<template>
  <div class="login" :style="{ background: bgImg ? bgImg : '' }">
    <div class="stars"></div>
    <div class="loginBOX">
      <div class="title">{{homeFile.title?homeFile.title:'四川省雪亮工程云平台'}}</div>
      <div class="titlePinyin">{{homeFile.titlePinyin?homeFile.titlePinyin:'Xueliang Project of Sichuan Province'}}</div>
      <div class="input-box">
        <span class="welcome">欢迎登录</span>
        <el-form :model="loginParams" :rules="rules" ref="loginParams">
          <div>
            <el-form-item prop="account">
              <el-input
                placeholder="请输入账号"
                auto-complete="off"
                name="phonenumber"
                maxlength="11"
                v-model="loginParams.account"
              >
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="password">
              <el-input
                placeholder="请输入密码"
                style="width: 250px"
                :type="pwdType"
                v-model="loginParams.password"
              >
                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                <span
                  class="el-icon-view"
                  style="font-size: 16px; cursor: pointer"
                  slot="suffix"
                  :style="{ opacity: eyes ? '1' : '0.6', color: '#C5DCE9' }"
                  @click="yanjing"
                ></span>
              </el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="rememberPwd">
          <el-checkbox v-model="checked">记住密码</el-checkbox>
          <div class="forgetPwd" @click="forgetPwd" style="">忘记密码</div>
        </div>
        <el-button
          class="button"
          :class="
            loginParams.account == '' || loginParams.password == '' ? 'disabled-btn' : ''
          "
          :disabled="loginParams.account == '' || loginParams.password == ''"
          :loading="loading"
          @click="login()"
          type="primary"
          >登录</el-button
        >
      </div>
    </div>
    <div class="download">
      <div class="QRCode">
        <img style="width: 100%; height: 100%" :src="homeFile.androidImg" />
      </div>
      <div class="other-load">
        <div class="download-but" @click.self="CRcode = !CRcode"><span class="iconfont iconanzhuo"></span> <span>手机端下载</span></div>
        <div class="download-but" @click="getPcEXE()"><span class="iconfont iconPC"></span> <span>PC端下载</span></div>
        <div class="download-but" @click="getPcDoc()"><span class="iconfont iconcaozuo"></span> <span>平台操作文档下载</span></div>
        <div class="download-but" @click="getAppDoc()"><span class="iconfont icontelephone"></span> <span>APP操作文档下载</span></div>
      </div>
    </div>
    <div class="login-info">
      <p v-if="homeFile.undertakeUnit"><span>承办单位 ：</span><span>{{homeFile.undertakeUnit}}</span></p>
      <p v-if="homeFile.constructionUnit"><span>建设单位 ：</span><span>{{homeFile.constructionUnit}}</span></p>
      <p v-if="homeFile.supportUnit"><span>技术支持 ：</span>{{homeFile.supportUnit}}</p>
    </div>
  </div>
</template>

<script>
let Base64 = require("js-base64").Base64;
import { loginApi } from "../../../api-path/login-api";
import { cameraApi } from "../../../api-path/district-api.js";
import publicAPI from "../../../api-path/public-api.js";
import validator from "./formValidator";
const host = window.location.host;
// const host2=document.domain;
// console.log(host,host2)
export default {
  name: "login",
  data() {
    return {
      showMsg:false,
      bgImg: "url(" + require("../../../assets/images/login/bg1.jpg") + ")",
      loading: false,
      pwdType: "password",
      CRcode: false,
      eyes: false,
      loginParams: {
        account: "",
        loginType: "PC",
        remember: true,
        password: "",
      },
      rules: {
        account: [
          {
            validator: validator.accountValidator,
            trigger: "blur",
          },
        ],
        password: [
          {
            validator: validator.passwordValidator,
            trigger: "blur",
          },
        ],
      },
      checked: false,
      longinData: {},
      imgInfo: {},
      homeFile: "",
    };
  },
  created() {
    this.getStorageInfo();
    this.getHomeFile();
  },
  mounted() {},
  methods: {
    checkedQR() {
      this.CRcode = !this.CRcode;
    },
    yanjing() {
      this.pwdType = this.pwdType === "password" ? "text" : "password";
      this.eyes = !this.eyes;
    },
    forgetPwd() {
      this.$router.push("/changePaw");
    },
    getHomeFile() {
      this.$http
        .get(publicAPI.version, {
          params: {
            domain: host,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.homeFile = res.result;
            this.bgImg = res.result.bgImg?'url(' + res.result.bgImg + ')':"url(" + require("../../../assets/images/login/bg1.jpg") + ")";
            localStorage.setItem('homeFile',JSON.stringify(res.result))
          }
        });
    },
    getPcEXE() {
      if (typeof window.QCefClient !== "undefined") {
        this.$alert("请在网页打开页面下载", "PC下载", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        // window.QCefClient.invokeMethod('QCef_Open_Web_Dialog',this.homeFile.pc,'下载新版本')
      } else {
        window.open(this.homeFile.pc);
      }
    },
    getPcDoc(){
      window.open("./static/doc/雪亮工程接警平台操作文档.docx");
      // window.open("https://xl.oss.honggv.cn:19101/group1/M00/00/2B/Ctd6BWIgF4iAGKUBAPHeQhZoJ3U01.docx?attname=平台操作文档.docx");
    },
    getAppDoc(){
      window.open("./static/doc/雪亮工程APP用户端操作文档.doc");
      // window.open("https://xl.oss.honggv.cn:19101/group1/M00/00/2D/Ctd6B2IgGjiAUTe6AQTOFiRqhhE362.doc?attname=APP操作文档.doc");
    },
    // 回去缓存信息
    getStorageInfo() {
      if (localStorage.getItem("c")) {
        this.checked = JSON.parse(localStorage.getItem("c"));
        if (this.checked) {
          if (localStorage.getItem("a")) {
            let account = localStorage.getItem("a");
            account = JSON.parse(account);
            this.loginParams = account;
          }
        }
      }
    },

    // 登录
    login() {
      let params = {
        ...this.loginParams,
      };
      // params.password = this.crypto.encrypt(this.loginParams.password);
      let oldParams = JSON.parse(JSON.stringify(params));
      params.remember = this.checked;
      params.password = Base64.encode(params.password);
      // if (this.checked) {
      localStorage.setItem("c", this.checked);
      // }
      this.loading = true;
      this.$http.post(loginApi.login, params).then((res) => {
        this.loading = false;
        if (res.status == 200) {
          localStorage.setItem("ur", JSON.stringify(res.result)); //所有返回信息
          localStorage.setItem("token", JSON.stringify(res.result.token)); //所有返回信息
          localStorage.setItem("a", JSON.stringify(oldParams));
          localStorage.setItem("p", res.result.realName);
          localStorage.setItem("centerId", res.result.centerId);
          localStorage.setItem("areaName", res.result.address);
          localStorage.setItem("phone", res.result.phone);
          sessionStorage.setItem("userId", res.result.id);
          if (
            res.result &&
            res.result.sourceTreeDTOList &&
            res.result.sourceTreeDTOList.length > 0
          ) {
            localStorage.setItem(
              "menuSettings",
              JSON.stringify(res.result.sourceTreeDTOList[0].sourceTreeDTOList)
            );
          }

          this.$http.get(cameraApi.codeAndItem).then((res) => {
            if (res.status === 200) {
              this.$store.commit("initMenu", this);
              localStorage.setItem("codeData", JSON.stringify(res.result));

              if (typeof QCefQuery !== "undefined") {
                this.getPcCurrentVersion();
              }
              this.$router.push("/home");
            }
          });

          let href =
            window.location.origin + "/static/Tree/tree.html?token=" + res.result.token; //所有返回信息;
          if (typeof window.QCefClient !== "undefined") {
            window.QCefClient.invokeMethod("QCEF_INIT_CAMERA_DIALOG", href);
          }
        }
      });
    },

    versionController(versionNo) {
      this.$http
        .get(publicAPI.getVersion, {
          params: {
            appType: "PC",
            version: versionNo,
          },
        })

        .then((data) => {
          if (data.status == 200) {
            let version = data.result;
            if (version && version.needUpdate) {
              // 调用张瑞的壳升级客户端
              if (typeof QCefClient !== "undefined") {
                if (version.url.indexOf("http") === -1) {
                  version.needUpdate = version.force;
                }
                const jsons = JSON.stringify(version);
                QCefClient.invokeMethod("QCef_Version_Update", jsons);
              }
              if (!version.force) {
                this.$router.push("/home");
              }
            } else {
              this.$router.push("/home");
            }
          }
        });
    },

    getPcCurrentVersion() {
      const $this = this;
      // 调用张瑞客户端获取版本
      // this.versionController("1.0.0");
      if (typeof QCefQuery !== "undefined") {
        QCefQuery({
          request: "QCefQuery_CheckVersion",
          onSuccess: function (response) {
            $this.versionController(response);
          },
          onFailure: function (error_code, error_message) {
            console.log(error_code, error_message);
          },
        });
      }
    },
  },
};
</script>

<style lang="less">
.login {
  .el-input--prefix .el-input__inner{
    padding-left: 0;
  }
  .headerImg {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 90px;
    display: flex;
    align-items: center;
    .headerImg-left {
      flex: 1;
      height: 100%;
      background-image: url(../../../assets/images/home/head-left.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .headerImg-middle {
      min-width: 200px;
      height: 100%;
      display: flex;
      justify-content: center;
      font-size: 45px;
      color: #fff;
      line-height: 80px;
      font-weight: bold;
      background-image: url(../../../assets/images/home/head-middle.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-shadow: 10px 10px 10px #03adef;
      font-style: italic;
      padding: 0 20px;
    }
    .headerImg-right {
      flex: 1;
      height: 100%;
      background-image: url(../../../assets/images/home/head-right.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }

  .el-input__inner {
    border: none;
    font-size: 16px;
    font-weight: 400;
    background: transparent;
    padding: 16px 0 12px;
    color: #C0C4CC;
  }

  .el-form-item__error {
    font-size: 14px;
  }

  .el-checkbox {
    color: #4d4d4d;
  }

  .el-popover {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none;
  }
}
</style>
<style lang="less" scoped>
@import "./login";
</style>
